import React from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { handleOpenStartNewJobModal } from '../../../../helpers/handleOpenStartNewJobModal';

import { Button } from '../../../../design-system';
import CircularIcon from '../../../../design-system/CircularIcon/CircularIcon';
import CheckLineIcon from '../../../../design-system/Icons/CheckLineIcon';

SuccessStartNewJobState.propTypes = {
    jobId: PropTypes.string,
    processName: PropTypes.string.isRequired,
    viewMode: PropTypes.oneOf(['fullScreen', 'partialScreen']),
    onStartFromSameProcess: PropTypes.func.isRequired,
};

function SuccessStartNewJobState({
    jobId,
    processName,
    viewMode = 'fullScreen',
    onStartFromSameProcess,
}) {
    const navigate = useNavigate();

    const openJobDetailsPage = () => {
        navigate(`/job/${jobId}`);
    };

    return (
        <div
            className={`px-3 py-[80px] w-full ${
                viewMode === 'fullScreen' && 'sm:w-[calc(100%-68px)] sm:px-8 sm:py-[140px]'
            } `}
        >
            <div className="py-5 max-w-[460px] mx-auto flex flex-col gap-[40px]">
                <div className="flex flex-col items-center gap-4 pb-[40px] border-b-1 border-neutral-200">
                    <CircularIcon icon={CheckLineIcon} color="lime" />
                    <p className="font-body text-body-regular-xs text-neutral-300 uppercase">
                        Job Successfully started
                    </p>
                    <p className="font-heading-bold text-heading-bold-m text-black text-center">
                        {processName} has been started!
                    </p>
                    <p className="font-body text-body-regular-s text-neutral-400 text-center">
                        To follow progress of this job, go to the job details page.
                    </p>
                    <Button
                        type="link"
                        size="sm"
                        text="View Job Details"
                        onClick={openJobDetailsPage}
                    />
                </div>
                <div className="flex flex-col gap-3">
                    <p className="font-body text-body-regular-s text-neutral-400 text-center">
                        Start a <span className="font-body-bold text-body-bold-s">New Job</span>{' '}
                        from:
                    </p>
                    <div className="flex gap-2 items-center">
                        <div className="min-w-[calc((100%-8px)/2)] flex flex-col">
                            <Button
                                type="ghost"
                                size="sm"
                                text="Same Agent"
                                onClick={onStartFromSameProcess}
                            />
                        </div>
                        <div className="min-w-[calc((100%-8px)/2)] flex flex-col">
                            <Button
                                type="secondary"
                                size="sm"
                                text="New Agent"
                                onClick={handleOpenStartNewJobModal}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SuccessStartNewJobState;
